import PropTypes from 'prop-types';
// material
import { Paper, Typography } from '@mui/material';
import { useTranslation } from '../common/LocalizationProvider';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string
};

// eslint-disable-next-line no-unused-vars
export default function SearchNotFound({ searchQuery = '', ...other }) {
  const t = useTranslation();
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        {t('tableEmpty_Title')}
      </Typography>
      <Typography variant="body2" align="center">
        {t('tableEmpty_Description')}
      </Typography>
    </Paper>
  );
}
